enum UserRole {
    UNKNOWN = "unknown",
    TEACHER = "teacher",
    STUDENT = "student",
    CARE = "care"
}

export default UserRole;